export default __webpack_public_path__ + "static/media/biobit-black.ed2b5671.svg";